import Loader from 'components/Preloader/Loader'
import * as React from 'react'
import Page from './shared/page_wrapper'

export const LoaderPage: React.FC = () => (
  <Page page="loader" stopTracking noContent>
    <Loader />
  </Page>
)
